import { DocumentKind, ServiceKind } from "@bitory-gmbh/bsm";
import { backendApi } from "@/services/backend/api";
import { Relationship } from "@/services/backend/relationships/types/relationship";
import { UUID } from "@bitory-gmbh/nidavellir";

const svc = backendApi.injectEndpoints({
  endpoints: (build) => ({
    relationshipsCommitmentsFromDocument: build.mutation<
      Relationship,
      CreateCommitmentsFromDocumentRequest
    >({
      query: (request) => ({
        url: "relationships/commitments-from-document",
        method: "POST",
        body: request,
      }),
      invalidatesTags: [
        "RelationshipsRelationship",
        "RelationshipsRelationshipCommitment",
      ],
    }),
  }),
});

export const { useRelationshipsCommitmentsFromDocumentMutation } = svc;

export interface CreateCommitmentsFromDocumentRequest {
  relationshipId: UUID;
  documentId: UUID;
  documentKind: DocumentKind;
  serviceKind: ServiceKind;
  processId?: UUID;
  splitByCycle: boolean;
  date: string;
}
